// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schoolLeaguesPage {
  width: 100%;
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.schoolLeaguesPage__header {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0;
  margin-bottom: 16px;
}
.schoolLeaguesPage__header h1 {
  margin: 0 0 3px;
  color: #142033;
  font-size: 26px;
  font-weight: 750;
  letter-spacing: -0.025em;
}
.schoolLeaguesPage__header p {
  margin: 0;
  color: #69778a;
  font-size: 13px;
}
.leagueButton {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  list-style: none;
}
.leagueButton--primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.leagueButton.is-active {
  border-color: #9bc9e7;
  background: #eef7fd;
  color: #155d8c;
}
.schoolLeaguesPage__toolbar {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  min-width: 0;
  flex: 1;
  margin-left: 18px;
}
.schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {
  display: flex;
  width: 210px;
  min-width: 0;
  flex-direction: column;
  margin: 0;
}

.schoolLeaguesPage__search > span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.leagueButton > svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}
.schoolLeaguesPage__search input {
  width: 100%;
  height: var(--control-h-md, 40px);
  min-width: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  outline: 0;
  background: var(--surface-card, #fff);
  box-shadow: none;
  color: var(--text-strong, #0f172a);
  font-size: var(--text-md, 14px);
}

.schoolLeaguesPage__search input::placeholder {
  color: #94a3b8;
}

.schoolLeaguesPage__search input:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.schoolLeaguesPage__toolbar > .leagueButton--primary {
  margin-left: auto;
}
.schoolLeaguesPage__toolbar details {
  position: relative;
}
.schoolLeaguesPage__toolbar details > div {
  position: absolute;
  z-index: 20;
  top: 46px;
  right: 0;
  display: grid;
  width: 260px;
  padding: 7px;
  border: 1px solid #dbe3ec;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
}
.schoolLeaguesPage__toolbar details > div button {
  padding: 9px;
  border: 0;
  border-radius: 6px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  text-align: left;
}
.schoolLeaguesPage__toolbar details > div button:hover {
  background: #f1f5f9;
}
.schoolLeaguesPage__filterControl,
.schoolLeaguesPage__columns {
  position: relative;
}
.schoolLeaguesPage__popoverScrim {
  position: fixed;
  z-index: 40;
  inset: 0;
  border: 0;
  background: transparent;
}
.schoolLeaguesPage__filterControl > .leagueButton,
.schoolLeaguesPage__columns > .leagueButton {
  position: relative;
  z-index: 41;
  gap: 7px;
}
.schoolLeaguesPage__filterDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #227ebd;
}
.schoolLeaguesPage__filterPopover,
.schoolLeaguesPage__columnsMenu {
  position: absolute;
  z-index: 42;
  top: calc(100% + 7px);
  right: 0;
  overflow: hidden;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
}
.schoolLeaguesPage__filterPopover {
  width: 410px;
  max-width: calc(100vw - 32px);
}
.schoolLeaguesPage__filterPopover > header {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e6ebf1;
}
.schoolLeaguesPage__filterPopover > header strong {
  color: #142033;
  font-size: 15px;
  font-weight: 800;
}
.schoolLeaguesPage__filterPopover > header button {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 20px;
}
.schoolLeaguesPage__filterFields {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  padding: 16px;
}
.schoolLeaguesPage__filterFields label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
}
.schoolLeaguesPage__filterFields label > span {
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.schoolLeaguesPage__filterFields input,
.schoolLeaguesPage__filterFields select {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  outline: none;
  background: #fff;
  color: #334155;
  font: inherit;
  font-size: 13px;
}
.schoolLeaguesPage__select {
  position: relative;
  display: block;
}
.schoolLeaguesPage__select::after {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 7px;
  height: 7px;
  border-right: 2px solid #64748b;
  border-bottom: 2px solid #64748b;
  content: '';
  pointer-events: none;
  transform: translateY(-70%) rotate(45deg);
}
.schoolLeaguesPage__select select {
  padding-right: 38px;
  appearance: none;
}
.schoolLeaguesPage__filterFields input:focus,
.schoolLeaguesPage__filterFields select:focus {
  border-color: #227ebd;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);
}
.schoolLeaguesPage__filterPopover > footer {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px;
  border-top: 1px solid #e6ebf1;
}
.schoolLeaguesPage__filterPopover > footer > div {
  display: flex;
  gap: 8px;
}
.schoolLeaguesPage__filterPopover > footer button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.schoolLeaguesPage__filterPopover > footer button.is-clear {
  padding: 0;
  border-color: transparent;
  color: #1a6da3;
}
.schoolLeaguesPage__filterPopover > footer button.is-apply {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.schoolLeaguesPage__columnsMenu {
  width: 235px;
  padding: 8px;
}
.schoolLeaguesPage__columnsMenu header {
  padding: 7px 8px 9px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.schoolLeaguesPage__columnsMenu label {
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 9px;
  margin: 0;
  padding: 0 8px;
  border-radius: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 650;
}
.schoolLeaguesPage__columnsMenu label > span {
  min-width: 0;
  flex: 1;
  color: #334155;
  line-height: 1.3;
}
.schoolLeaguesPage__columnsMenu label input {
  flex: 0 0 16px;
}
.schoolLeaguesPage__columnsMenu label:hover {
  background: #f8fafc;
}
.schoolLeaguesPage__chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 9px;
}
.schoolLeaguesPage__chips button {
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #b9d9ee;
  border-radius: 999px;
  background: #eef7fd;
  color: #155d8c;
  font-size: 12px;
  font-weight: 700;
}
.schoolLeaguesPage__chips button span {
  margin-left: 5px;
  font-size: 16px;
  line-height: 1;
}
.schoolLeaguesPage__chips button.is-clear {
  border-color: transparent;
  background: transparent;
  color: #1a6da3;
}
.schoolLeaguesPage__selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 9px;
  padding: 9px 12px;
  border: 1px solid #b9d9ee;
  border-radius: 9px;
  background: #eef7fd;
  color: #155d8c;
  font-size: 12.5px;
  font-weight: 700;
}
.schoolLeaguesPage__selection > div {
  display: flex;
  gap: 6px;
}
.schoolLeaguesPage__selection button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #b9d9ee;
  border-radius: 7px;
  background: #fff;
  color: #155d8c;
  font: inherit;
  font-size: 12px;
}
.schoolLeaguesPage__selection button.is-danger {
  border-color: #efb4bd;
  color: #a7283b;
}
.schoolLeaguesPage__card {
  overflow-x: auto;
  margin-top: 10px;
  border: 1px solid #dbe3ec;
  border-radius: 11px;
  background: #fff;
}
.schoolLeaguesPage__card table {
  width: 100%;
  border-collapse: collapse;
}
.schoolLeaguesPage__card th {
  padding: 10px 12px;
  background: #f8fafc;
  color: #69778a;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-align: left;
  text-transform: uppercase;
}
.schoolLeaguesPage__card th button {
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-transform: inherit;
}
.schoolLeaguesPage__card td {
  padding: 11px 12px;
  border-top: 1px solid #edf1f5;
  color: #475569;
  font-size: 13px;
}
.schoolLeaguesPage__card th:first-child,
.schoolLeaguesPage__card td:first-child {
  width: 44px;
  text-align: center;
}
.schoolLeaguesPage__card input[type='checkbox'],
.schoolLeaguesPage__columnsMenu input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #227ebd;
}
.schoolLeaguesPage__card th:last-child,
.schoolLeaguesPage__card td:last-child {
  width: 50px;
  text-align: right;
}
.schoolLeaguesPage__card tbody tr {
  cursor: pointer;
}
.schoolLeaguesPage__card tbody tr:hover {
  background: #fbfdff;
}
.schoolLeaguesPage__card tbody tr.is-selected {
  background: #eef7fd;
}
.schoolLeaguesPage__name {
  display: flex;
  align-items: center;
  gap: 10px;
}
.schoolLeaguesPage__name > i {
  display: flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eaf4fb;
  font-style: normal;
  color: #227ebd;
}
.schoolLeaguesPage__leagueIcon {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}
.schoolLeaguesPage__name > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.schoolLeaguesPage__name strong {
  color: #142033;
  font-size: 13.5px;
  font-weight: 650;
}
.schoolLeaguesPage__name small {
  max-width: 440px;
  overflow: hidden;
  color: #8491a3;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schoolLeaguesPage__type,
.schoolLeaguesPage__site {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: #526174;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
}
.schoolLeaguesPage__type.is-house {
  background: #f3edff;
  color: #6b46a1;
}
.schoolLeaguesPage__type.is-individual {
  background: #edf8f1;
  color: #267344;
}
.schoolLeaguesPage__site.is-published {
  background: #eaf7ef;
  color: #237044;
}
.schoolLeaguesPage__site.is-protected {
  background: #fff6df;
  color: #946200;
}
.schoolLeaguesPage__site.is-disabled {
  background: #eef2f6;
  color: #64748b;
}

.leagueReportsModal.modal-dialog {
  max-width: 720px;
}
.leagueReportsModal .modal-content,
.leagueReportParametersModal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.leagueReportsModal .modal-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e5eaf0;
}
.leagueReportsModal .modal-title {
  color: #142033;
  font-size: 19px;
  font-weight: 800;
}
.leagueReportsModal .modal-body {
  padding: 0;
}

.leagueReportsModal .eEventPrintModal__intro {
  padding: 16px 20px;
  border-bottom: 1px solid #e5eaf0;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.leagueReportsModal .eEventPrintModal__group {
  padding: 18px 20px 20px;
}

.leagueReportsModal .eEventPrintModal__groupTitle {
  margin: 0 0 10px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

.leagueReportsModal .eEventPrintModal__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.leagueReportsModal .eEventPrintModal__item {
  display: grid;
  min-height: 72px;
  grid-template-columns: 40px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.leagueReportsModal .eEventPrintModal__item:hover:not(:disabled) {
  border-color: #9bc9e7;
  background: #f8fcff;
}

.leagueReportsModal .eEventPrintModal__item:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.leagueReportsModal .eEventPrintModal__itemIcon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eaf4fb;
  color: #227ebd;
}

.leagueReportsModal .eEventPrintModal__itemIcon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.leagueReportsModal .eEventPrintModal__itemCopy,
.leagueReportsModal .eEventPrintModal__itemHeading {
  display: flex;
  min-width: 0;
}

.leagueReportsModal .eEventPrintModal__itemCopy {
  flex-direction: column;
  gap: 4px;
}

.leagueReportsModal .eEventPrintModal__itemHeading {
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #142033;
  font-size: 13.5px;
  font-weight: 750;
}

.leagueReportsModal .eEventPrintModal__format {
  padding: 3px 7px;
  border-radius: 999px;
  background: #edf2f7;
  color: #64748b;
  font-size: 10.5px;
  font-weight: 750;
}

.leagueReportsModal .eEventPrintModal__itemDescription {
  color: #69778a;
  font-size: 11.5px;
  line-height: 1.4;
}

.leagueReportsModal .eEventPrintModal__arrow {
  color: #94a3b8;
  font-size: 24px;
  line-height: 1;
}
.leagueReportsPicker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 18px 20px 20px;
}
.leagueReportsPicker > p {
  grid-column: 1/-1;
  margin: 0 0 5px;
  color: #69778a;
  font-size: 13px;
}
.leagueReportsPicker > button {
  min-height: 82px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 16px;
  align-items: center;
  gap: 11px;
  padding: 12px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
}
.leagueReportsPicker > button:hover:not(:disabled) {
  border-color: #9bc9e7;
  background: #fbfdff;
}
.leagueReportsPicker > button:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}
.leagueReportsPicker > button > i {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eaf4fb;
  color: #227ebd;
  font-style: normal;
}
.leagueReportsPicker span {
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.leagueReportsPicker strong {
  color: #142033;
  font-size: 13px;
}
.leagueReportsPicker small {
  margin-top: 3px;
  color: #69778a;
  font-size: 11px;
  line-height: 1.35;
}
.leagueReportsPicker b {
  color: #94a3b8;
}
.leagueReportParametersModal.modal-dialog {
  max-width: 660px !important;
}
.leagueReportParametersModal .modal-header {
  min-height: 76px;
  padding: 14px 18px;
  border-bottom: 1px solid #e3e8ef;
  background: #fff;
}
.leagueReportModalTitle {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.leagueReportModalTitle__icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef8ff;
  color: #17659a;
}
.leagueReportModalTitle__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}
.leagueReportModalTitle__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.leagueReportModalTitle__name {
  color: #142033;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}
.leagueReportModalTitle__category {
  margin-top: 2px;
  color: #64748b;
  font-size: 12.5px;
}
.leagueReportParametersModal .modal-body {
  padding: 0 !important;
}
.leagueReportParametersModal .modal-content {
  max-height: min(760px, calc(100vh - 40px));
}
.leagueReportParametersModal__body > form {
  display: flex;
  flex-wrap: wrap;
  max-height: calc(100vh - 118px);
  overflow-y: auto;
  color: #334155;
  font-size: 13px;
}
.leagueReportParametersModal__body .bReportFormTitle {
  display: none;
}
.leagueReportParametersModal__body > form > .mb-3.mt-3,
.leagueReportParametersModal__body .bReportFormTitle + .mb-3,
.leagueReportParametersModal__body .form-check,
.leagueReportParametersModal__body .form-group {
  box-sizing: border-box;
  width: calc(100% - 48px);
  margin: 6px 24px !important;
  padding: 13px 14px;
  border: 1px solid #e3e8ef;
  border-radius: 11px;
  background: #fff;
}
.leagueReportParametersModal__body > form > .mb-3.mt-3,
.leagueReportParametersModal__body .bReportFormTitle + .mb-3 {
  margin-top: 18px !important;
  background: #f8fafc;
}
.leagueReportParametersModal__body .form-check .form-check {
  width: 100%;
  margin: 8px 0 0 !important;
}
.leagueReportParametersModal__body label {
  color: #142033;
  font-size: 13px;
  font-weight: 650;
}
.leagueReportParametersModal__body .form-control {
  min-height: 42px;
  border: 1px solid #cfd8e3;
  border-radius: 9px;
  box-shadow: none;
}
.leagueReportParametersModal__body .form-control:focus {
  border-color: #2684c7;
  box-shadow: 0 0 0 3px rgba(38, 132, 199, 0.12);
}
.leagueReportParametersModal__body form > .btn {
  min-width: 96px;
  min-height: 40px;
  order: 98;
  margin-top: 18px !important;
  margin-bottom: 18px !important;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
.leagueReportParametersModal__body form > .btn-secondary {
  margin-right: 8px !important;
  margin-left: 24px !important;
  border-color: #cbd5e1;
  background: #fff;
  color: #475569;
}
.leagueReportParametersModal__body form > .btn-primary {
  order: 99;
  margin-right: 24px !important;
  margin-left: auto !important;
  border-color: #227ebd;
  background: #227ebd;
}

.leagueReportParametersModal__body .sit-switch {
  min-height: 24px;
  align-items: center;
}

.leagueReportParametersModal__body .form-check > .d-flex {
  align-items: center;
}

.leagueReportParametersModal__body .form-check-label {
  margin: 0;
}

.leagueReportParametersModal__body .leagueReportForm__footer {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding: 14px 24px;
  border-top: 1px solid #e3e8ef;
  background: #fff;
}

.leagueReportParametersModal__body .leagueReportForm__footer .btn {
  min-height: 40px;
  margin: 0 !important;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

/* Shared report controls — same structure as People / Students report modals. */
.leagueReportParametersModal.modal-dialog {
  height: min(760px, calc(100vh - 48px));
}

.leagueReportParametersModal .modal-content {
  height: 100% !important;
  max-height: 100% !important;
}

.leagueReportParametersModal .modal-body,
.leagueReportParametersModal__body {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden !important;
}

.leagueReportParametersModal__body > form.eReportForm {
  display: flex !important;
  width: 100%;
  height: auto;
  min-height: 0;
  flex: 1 1 0;
  flex-flow: column nowrap;
  overflow: hidden;
  background: #fff;
}

.leagueReportParametersModal .eReportForm__scroll {
  min-height: 0;
  flex: 1 1 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.leagueReportParametersModal .eReportDescription {
  margin: 18px 24px 8px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
  background: var(--slate-25, #f8fafc);
  color: var(--text-body, #334155);
  font-size: 13.5px;
  line-height: 1.55;
}

.leagueReportParametersModal .eReportSection {
  margin: 16px 24px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
}

.leagueReportParametersModal .eReportSection__heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.leagueReportParametersModal .eReportSection__icon {
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
  font-size: 12px;
  font-weight: 800;
}

.leagueReportParametersModal .eReportSection__title {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}

.leagueReportParametersModal .eReportSection__required {
  margin-left: 3px;
  color: #c23648;
}

.leagueReportParametersModal .eReportSection__hint {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.leagueReportParametersModal .eReportToggleList {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
}

.leagueReportParametersModal .eReportToggle {
  display: flex;
  min-height: 56px;
  align-items: center;
  gap: 16px;
  padding: 10px 13px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: #fff;
}

.leagueReportParametersModal .eReportToggle:first-child {
  border-top: 0;
}

.leagueReportParametersModal .eReportSection > .eReportToggle {
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
}

.leagueReportParametersModal .eReportToggle__copy {
  min-width: 0;
  flex: 1;
}

.leagueReportParametersModal .eReportToggle__label {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
}

.leagueReportParametersModal .eReportToggle__hint {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}

.leagueReportParametersModal .eReportToggle .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}

.leagueReportParametersModal .eReportSection__chips {
  margin-top: 12px;
}

.leagueReportParametersModal .eReportCheckboxGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.leagueReportParametersModal .eReportCheckbox {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border: 1px solid #dbe3ec;
  border-radius: 999px;
  background: #fff;
  color: #526174;
  font: 600 12px var(--font-body, inherit);
}

.leagueReportParametersModal .eReportCheckbox__box {
  display: none;
}

.leagueReportParametersModal .eReportCheckbox--active {
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.leagueReportParametersModal .eReportAgeGroups {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.leagueReportParametersModal .eReportAgeGroup {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}

.leagueReportParametersModal .eReportAgeGroup__title {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  color: #334155;
  font-size: 12px;
}

.leagueReportParametersModal .eReportAgeGroup__title span {
  color: #94a3b8;
  font-size: 10px;
}

.leagueReportParametersModal .eReportDateRange,
.leagueReportParametersModal .eReportDateRange__picker {
  width: 100%;
}

.leagueReportParametersModal .eReportActions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 9px;
  padding: 14px 24px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: var(--slate-25, #f8fafc);
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.04);
}

.leagueReportParametersModal .eReportActions__status {
  flex: 1;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.leagueReportParametersModal .eDsButton {
  min-height: 40px;
  padding: 8px 15px;
  border-radius: 9px;
  font: 700 13px var(--font-body, inherit);
}

.leagueReportParametersModal .eDsButton--secondary {
  border: 1px solid var(--border-default, #cfd8e3);
  background: #fff;
  color: var(--text-strong, #142033);
}

.leagueReportParametersModal .eDsButton--primary {
  border: 1px solid var(--blue-600, #1f78b4);
  background: var(--blue-600, #1f78b4);
  color: #fff;
}

@media (max-width: 560px) {
  .leagueReportParametersModal .eReportDescription,
  .leagueReportParametersModal .eReportSection {
    margin-right: 14px;
    margin-left: 14px;
  }

  .leagueReportParametersModal .eReportActions {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 14px;
  }

  .leagueReportParametersModal .eDsButton {
    width: 100%;
  }
}
.schoolLeaguesPage__more {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #69778a;
}
.schoolLeaguesPage__empty {
  height: 180px;
  color: #69778a !important;
  text-align: center !important;
}
.schoolLeaguesPage__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 58px;
  margin-top: 0;
  padding: 12px 14px;
  border: 1px solid #dbe3ec;
  border-top: 0;
  border-radius: 0 0 11px 11px;
  background: #fff;
}
.schoolLeaguesPage__paginationInfo {
  color: #69778a;
  font-size: 12px;
  font-weight: 600;
}
.schoolLeaguesPage__pagination > div {
  display: flex;
  align-items: center;
  gap: 5px;
}
.schoolLeaguesPage__pagination > div > span {
  min-width: 22px;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
}
.schoolLeaguesPage__pagination button {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.schoolLeaguesPage__pagination button:hover:not(:disabled):not(.is-active) {
  border-color: #9bc9e7;
  background: #f7fbfe;
  color: #155d8c;
}
.schoolLeaguesPage__pagination button.is-active {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.schoolLeaguesPage__pagination button.is-arrow {
  font-size: 20px;
  line-height: 1;
}
.schoolLeaguesPage__pagination button:disabled {
  background: #f8fafc;
  color: #b0bbc8;
  cursor: not-allowed;
}
.leaguesDrawer__scrim {
  position: fixed;
  z-index: 1090;
  inset: 0;
  border: 0;
  background: rgba(15, 23, 42, 0.35);
}
.leaguesDrawer {
  position: fixed;
  z-index: 1100;
  top: 0;
  right: 0;
  display: flex;
  width: min(500px, 100vw);
  height: 100vh;
  flex-direction: column;
  background: #fff;
  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.18);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.leaguesDrawer > header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 19px 20px;
  border-bottom: 1px solid #e5eaf0;
}
.leaguesDrawer > header > i {
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eaf4fb;
  font-style: normal;
  color: #227ebd;
}
.leaguesDrawer > header > div {
  min-width: 0;
}
.leaguesDrawer h2 {
  margin: 0;
  color: #142033;
  font-size: 18px;
  font-weight: 750;
}
.leaguesDrawer header p {
  margin: 3px 0 0;
  color: #69778a;
  font-size: 12px;
}
.leaguesDrawer header > button {
  width: 34px;
  height: 34px;
  margin-left: auto;
  border: 0;
  border-radius: 8px;
  background: #f1f5f9;
  color: #526174;
  font-size: 22px;
}
.leaguesDrawer > nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e5eaf0;
}
.leaguesDrawer > nav button {
  min-height: 44px;
  padding: 0 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: none;
  color: #69778a;
  font-size: 13px;
  font-weight: 650;
}
.leaguesDrawer > nav button.is-active {
  border-color: #227ebd;
  color: #155d8c;
}
.leaguesDrawer > nav span {
  margin-left: 5px;
  padding: 1px 5px;
  border-radius: 999px;
  background: #eef2f6;
  font-size: 9px;
}
.leaguesDrawer > main {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 18px 20px;
}
.leaguesDrawer > footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 13px 20px;
  border-top: 1px solid #e5eaf0;
}
.eSchoolLeaguesPhotos {
  max-width: 100%;
  border: 0;
  border-radius: 9px;
}
.bReportFormTitle {
  font-size: 18px;
  font-weight: bold;
}
.leaguesDrawer main table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}
.leaguesDrawer main table td {
  padding: 10px 0;
  border: 0;
  border-bottom: 1px solid #e5eaf0;
  color: #142033;
  font-size: 13.5px;
  vertical-align: top;
}
.leaguesDrawer main table td:first-child {
  width: 38%;
  color: #69778a;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.leaguesDrawer main table tr:last-child td {
  border-bottom: 0;
}
.leaguesDrawer main .leagueEventsSummary {
  table-layout: fixed;
}
.leaguesDrawer main .leagueEventsSummary th {
  padding: 9px 10px;
  border-bottom: 1px solid #e3e8ef;
  background: #f8fafc;
  color: #64748b;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-align: left;
  text-transform: uppercase;
}
.leaguesDrawer main .leagueEventsSummary th:first-child {
  width: 48%;
}
.leaguesDrawer main .leagueEventsSummary td,
.leaguesDrawer main .leagueEventsSummary td:first-child {
  width: auto;
  padding: 11px 10px;
  background: #fff;
  color: #334155;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}
.leaguesDrawer main .leagueEventsSummary td:first-child a {
  color: #176895;
  font-weight: 750;
}
.leaguesDrawer main .leagueNewsSummary__body {
  display: -webkit-box;
  max-width: 220px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: #64748b;
  line-height: 1.45;
}
@media (max-width: 760px) {
  .schoolLeaguesPage__header,
  .schoolLeaguesPage__toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .leagueReportsPicker {
    grid-template-columns: 1fr;
  }
  .schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {
    width: 100%;
  }
  .schoolLeaguesPage__toolbar {
    width: 100%;
    margin-left: 0;
  }
  .schoolLeaguesPage__filterPopover {
    position: fixed;
    top: auto;
    right: 12px;
    bottom: 12px;
    left: 12px;
    width: auto;
    max-width: none;
  }
}

/* School leagues — shared refreshed list shell. */
.schoolLeaguesRoute {
  width: 100%;
  margin-top: 0 !important;
}

.schoolLeaguesPage {
  min-width: 0;
  padding-bottom: 32px;
  background: var(--surface-page, #f8fafc);
}

.schoolLeaguesPage__header {
  box-sizing: border-box;
  display: flex;
  width: calc(100% + 48px);
  min-height: 78px;
  align-items: center;
  gap: 24px;
  margin: -20px 0 18px -24px;
  padding: 14px 72px 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.schoolLeaguesPage__header > div:first-child {
  min-width: 150px;
  flex: 0 0 auto;
}

.schoolLeaguesPage__header h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.18;
}

.schoolLeaguesPage__toolbar {
  align-items: center;
  margin-left: 0;
}

.schoolLeaguesPage__filterPopover {
  position: fixed;
  z-index: 1300;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: min(420px, 100vw);
  max-width: none;
  height: 100vh;
  flex-direction: column;
  border-width: 0 0 0 1px;
  border-radius: 0;
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}

.schoolLeaguesPage__popoverScrim {
  z-index: 1290;
}

.schoolLeaguesPage__filterPopover > header {
  margin: 18px 18px 0;
}

.schoolLeaguesPage__filterFields {
  min-height: 0;
  flex: 1;
  align-content: start;
  overflow-y: auto;
  padding: 18px;
}

.schoolLeaguesPage__filterChips {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.schoolLeaguesPage__filterChips legend {
  width: auto;
  margin: 0 0 9px;
  padding: 0;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 750;
}

.schoolLeaguesPage__filterChips > div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.schoolLeaguesPage__filterChips button {
  min-height: 34px;
  padding: 6px 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.schoolLeaguesPage__filterChips button:hover {
  border-color: #9bc9e7;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.schoolLeaguesPage__filterChips button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolLeaguesPage__filterChips button.is-selected:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

.schoolLeaguesPage__columns > .leagueButton,
.schoolLeaguesPage__columnsMenu {
  z-index: 1300;
}

.schoolLeaguesPage__card tbody tr {
  height: 56px;
}

.schoolLeaguesPage__card tbody tr:hover {
  background: var(--surface-sunken, #f1f5f9);
}

.schoolLeaguesPage__more {
  color: var(--text-subtle, #94a3b8);
  font-size: 25px;
  line-height: 1;
  opacity: 0;
  transition: opacity 120ms ease, color 120ms ease;
}

.schoolLeaguesPage__card tbody tr:hover .schoolLeaguesPage__more,
.schoolLeaguesPage__card tbody tr.is-selected .schoolLeaguesPage__more {
  color: var(--blue-600, #227ebd);
  opacity: 1;
}

.schoolLeaguesPage__card input[type='checkbox'],
.schoolLeaguesPage__columnsMenu input[type='checkbox'] {
  border-color: var(--border-default, #cbd5e1);
  border-radius: 4px;
  accent-color: var(--action-primary, #227ebd);
}

.leagueButton:hover:not(:disabled),
.schoolLeaguesPage__selection button:hover:not(:disabled) {
  border-color: #9bc9e7;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.leagueButton--primary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

@media (max-width: 1040px) {
  .schoolLeaguesPage__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .schoolLeaguesPage__toolbar {
    width: 100%;
    flex-wrap: wrap;
  }

  .schoolLeaguesPage__toolbar > .leagueButton--primary {
    margin-left: 0;
  }
}

@media (max-width: 620px) {
  .schoolLeaguesPage__header {
    width: calc(100% + 30px);
    margin-left: -15px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {
    width: 100%;
  }

  .schoolLeaguesPage__filterPopover {
    width: min(390px, 100vw);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/LeaguesAndCompetitions/Leagues/SchoolLeagues.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,MAAM;EACN,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;EAC9C,mEAAmE;AACrE;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,OAAO;EACP,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,wFAAwF;AAC1F;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,gDAAgD;AAClD;;AAEA;;EAEE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;;EAEE,4CAA4C;EAC5C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".schoolLeaguesPage {\n  width: 100%;\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.schoolLeaguesPage__header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 0;\n  margin-bottom: 16px;\n}\n.schoolLeaguesPage__header h1 {\n  margin: 0 0 3px;\n  color: #142033;\n  font-size: 26px;\n  font-weight: 750;\n  letter-spacing: -0.025em;\n}\n.schoolLeaguesPage__header p {\n  margin: 0;\n  color: #69778a;\n  font-size: 13px;\n}\n.leagueButton {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #475569;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n  list-style: none;\n}\n.leagueButton--primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.leagueButton.is-active {\n  border-color: #9bc9e7;\n  background: #eef7fd;\n  color: #155d8c;\n}\n.schoolLeaguesPage__toolbar {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  min-width: 0;\n  flex: 1;\n  margin-left: 18px;\n}\n.schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {\n  display: flex;\n  width: 210px;\n  min-width: 0;\n  flex-direction: column;\n  margin: 0;\n}\n\n.schoolLeaguesPage__search > span {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.leagueButton > svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n.schoolLeaguesPage__search input {\n  width: 100%;\n  height: var(--control-h-md, 40px);\n  min-width: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  outline: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-md, 14px);\n}\n\n.schoolLeaguesPage__search input::placeholder {\n  color: #94a3b8;\n}\n\n.schoolLeaguesPage__search input:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.schoolLeaguesPage__toolbar > .leagueButton--primary {\n  margin-left: auto;\n}\n.schoolLeaguesPage__toolbar details {\n  position: relative;\n}\n.schoolLeaguesPage__toolbar details > div {\n  position: absolute;\n  z-index: 20;\n  top: 46px;\n  right: 0;\n  display: grid;\n  width: 260px;\n  padding: 7px;\n  border: 1px solid #dbe3ec;\n  border-radius: 9px;\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);\n}\n.schoolLeaguesPage__toolbar details > div button {\n  padding: 9px;\n  border: 0;\n  border-radius: 6px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n  text-align: left;\n}\n.schoolLeaguesPage__toolbar details > div button:hover {\n  background: #f1f5f9;\n}\n.schoolLeaguesPage__filterControl,\n.schoolLeaguesPage__columns {\n  position: relative;\n}\n.schoolLeaguesPage__popoverScrim {\n  position: fixed;\n  z-index: 40;\n  inset: 0;\n  border: 0;\n  background: transparent;\n}\n.schoolLeaguesPage__filterControl > .leagueButton,\n.schoolLeaguesPage__columns > .leagueButton {\n  position: relative;\n  z-index: 41;\n  gap: 7px;\n}\n.schoolLeaguesPage__filterDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #227ebd;\n}\n.schoolLeaguesPage__filterPopover,\n.schoolLeaguesPage__columnsMenu {\n  position: absolute;\n  z-index: 42;\n  top: calc(100% + 7px);\n  right: 0;\n  overflow: hidden;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);\n}\n.schoolLeaguesPage__filterPopover {\n  width: 410px;\n  max-width: calc(100vw - 32px);\n}\n.schoolLeaguesPage__filterPopover > header {\n  min-height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-bottom: 1px solid #e6ebf1;\n}\n.schoolLeaguesPage__filterPopover > header strong {\n  color: #142033;\n  font-size: 15px;\n  font-weight: 800;\n}\n.schoolLeaguesPage__filterPopover > header button {\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  font-size: 20px;\n}\n.schoolLeaguesPage__filterFields {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n  padding: 16px;\n}\n.schoolLeaguesPage__filterFields label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n}\n.schoolLeaguesPage__filterFields label > span {\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n.schoolLeaguesPage__filterFields input,\n.schoolLeaguesPage__filterFields select {\n  width: 100%;\n  height: 40px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  outline: none;\n  background: #fff;\n  color: #334155;\n  font: inherit;\n  font-size: 13px;\n}\n.schoolLeaguesPage__select {\n  position: relative;\n  display: block;\n}\n.schoolLeaguesPage__select::after {\n  position: absolute;\n  top: 50%;\n  right: 13px;\n  width: 7px;\n  height: 7px;\n  border-right: 2px solid #64748b;\n  border-bottom: 2px solid #64748b;\n  content: '';\n  pointer-events: none;\n  transform: translateY(-70%) rotate(45deg);\n}\n.schoolLeaguesPage__select select {\n  padding-right: 38px;\n  appearance: none;\n}\n.schoolLeaguesPage__filterFields input:focus,\n.schoolLeaguesPage__filterFields select:focus {\n  border-color: #227ebd;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);\n}\n.schoolLeaguesPage__filterPopover > footer {\n  min-height: 58px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 16px;\n  border-top: 1px solid #e6ebf1;\n}\n.schoolLeaguesPage__filterPopover > footer > div {\n  display: flex;\n  gap: 8px;\n}\n.schoolLeaguesPage__filterPopover > footer button {\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n.schoolLeaguesPage__filterPopover > footer button.is-clear {\n  padding: 0;\n  border-color: transparent;\n  color: #1a6da3;\n}\n.schoolLeaguesPage__filterPopover > footer button.is-apply {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.schoolLeaguesPage__columnsMenu {\n  width: 235px;\n  padding: 8px;\n}\n.schoolLeaguesPage__columnsMenu header {\n  padding: 7px 8px 9px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.schoolLeaguesPage__columnsMenu label {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  padding: 0 8px;\n  border-radius: 7px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 650;\n}\n.schoolLeaguesPage__columnsMenu label > span {\n  min-width: 0;\n  flex: 1;\n  color: #334155;\n  line-height: 1.3;\n}\n.schoolLeaguesPage__columnsMenu label input {\n  flex: 0 0 16px;\n}\n.schoolLeaguesPage__columnsMenu label:hover {\n  background: #f8fafc;\n}\n.schoolLeaguesPage__chips {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 9px;\n}\n.schoolLeaguesPage__chips button {\n  min-height: 30px;\n  padding: 0 9px;\n  border: 1px solid #b9d9ee;\n  border-radius: 999px;\n  background: #eef7fd;\n  color: #155d8c;\n  font-size: 12px;\n  font-weight: 700;\n}\n.schoolLeaguesPage__chips button span {\n  margin-left: 5px;\n  font-size: 16px;\n  line-height: 1;\n}\n.schoolLeaguesPage__chips button.is-clear {\n  border-color: transparent;\n  background: transparent;\n  color: #1a6da3;\n}\n.schoolLeaguesPage__selection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 9px;\n  padding: 9px 12px;\n  border: 1px solid #b9d9ee;\n  border-radius: 9px;\n  background: #eef7fd;\n  color: #155d8c;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n.schoolLeaguesPage__selection > div {\n  display: flex;\n  gap: 6px;\n}\n.schoolLeaguesPage__selection button {\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #b9d9ee;\n  border-radius: 7px;\n  background: #fff;\n  color: #155d8c;\n  font: inherit;\n  font-size: 12px;\n}\n.schoolLeaguesPage__selection button.is-danger {\n  border-color: #efb4bd;\n  color: #a7283b;\n}\n.schoolLeaguesPage__card {\n  overflow-x: auto;\n  margin-top: 10px;\n  border: 1px solid #dbe3ec;\n  border-radius: 11px;\n  background: #fff;\n}\n.schoolLeaguesPage__card table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.schoolLeaguesPage__card th {\n  padding: 10px 12px;\n  background: #f8fafc;\n  color: #69778a;\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-align: left;\n  text-transform: uppercase;\n}\n.schoolLeaguesPage__card th button {\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  text-transform: inherit;\n}\n.schoolLeaguesPage__card td {\n  padding: 11px 12px;\n  border-top: 1px solid #edf1f5;\n  color: #475569;\n  font-size: 13px;\n}\n.schoolLeaguesPage__card th:first-child,\n.schoolLeaguesPage__card td:first-child {\n  width: 44px;\n  text-align: center;\n}\n.schoolLeaguesPage__card input[type='checkbox'],\n.schoolLeaguesPage__columnsMenu input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: #227ebd;\n}\n.schoolLeaguesPage__card th:last-child,\n.schoolLeaguesPage__card td:last-child {\n  width: 50px;\n  text-align: right;\n}\n.schoolLeaguesPage__card tbody tr {\n  cursor: pointer;\n}\n.schoolLeaguesPage__card tbody tr:hover {\n  background: #fbfdff;\n}\n.schoolLeaguesPage__card tbody tr.is-selected {\n  background: #eef7fd;\n}\n.schoolLeaguesPage__name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.schoolLeaguesPage__name > i {\n  display: flex;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #eaf4fb;\n  font-style: normal;\n  color: #227ebd;\n}\n.schoolLeaguesPage__leagueIcon {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.7;\n}\n.schoolLeaguesPage__name > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n.schoolLeaguesPage__name strong {\n  color: #142033;\n  font-size: 13.5px;\n  font-weight: 650;\n}\n.schoolLeaguesPage__name small {\n  max-width: 440px;\n  overflow: hidden;\n  color: #8491a3;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.schoolLeaguesPage__type,\n.schoolLeaguesPage__site {\n  display: inline-flex;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #526174;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n.schoolLeaguesPage__type.is-house {\n  background: #f3edff;\n  color: #6b46a1;\n}\n.schoolLeaguesPage__type.is-individual {\n  background: #edf8f1;\n  color: #267344;\n}\n.schoolLeaguesPage__site.is-published {\n  background: #eaf7ef;\n  color: #237044;\n}\n.schoolLeaguesPage__site.is-protected {\n  background: #fff6df;\n  color: #946200;\n}\n.schoolLeaguesPage__site.is-disabled {\n  background: #eef2f6;\n  color: #64748b;\n}\n\n.leagueReportsModal.modal-dialog {\n  max-width: 720px;\n}\n.leagueReportsModal .modal-content,\n.leagueReportParametersModal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.leagueReportsModal .modal-header {\n  padding: 18px 20px;\n  border-bottom: 1px solid #e5eaf0;\n}\n.leagueReportsModal .modal-title {\n  color: #142033;\n  font-size: 19px;\n  font-weight: 800;\n}\n.leagueReportsModal .modal-body {\n  padding: 0;\n}\n\n.leagueReportsModal .eEventPrintModal__intro {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5eaf0;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.leagueReportsModal .eEventPrintModal__group {\n  padding: 18px 20px 20px;\n}\n\n.leagueReportsModal .eEventPrintModal__groupTitle {\n  margin: 0 0 10px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.055em;\n  text-transform: uppercase;\n}\n\n.leagueReportsModal .eEventPrintModal__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.leagueReportsModal .eEventPrintModal__item {\n  display: grid;\n  min-height: 72px;\n  grid-template-columns: 40px minmax(0, 1fr) 18px;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 13px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  color: #334155;\n  text-align: left;\n  cursor: pointer;\n}\n\n.leagueReportsModal .eEventPrintModal__item:hover:not(:disabled) {\n  border-color: #9bc9e7;\n  background: #f8fcff;\n}\n\n.leagueReportsModal .eEventPrintModal__item:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.leagueReportsModal .eEventPrintModal__itemIcon {\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #eaf4fb;\n  color: #227ebd;\n}\n\n.leagueReportsModal .eEventPrintModal__itemIcon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.leagueReportsModal .eEventPrintModal__itemCopy,\n.leagueReportsModal .eEventPrintModal__itemHeading {\n  display: flex;\n  min-width: 0;\n}\n\n.leagueReportsModal .eEventPrintModal__itemCopy {\n  flex-direction: column;\n  gap: 4px;\n}\n\n.leagueReportsModal .eEventPrintModal__itemHeading {\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: #142033;\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.leagueReportsModal .eEventPrintModal__format {\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: #edf2f7;\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 750;\n}\n\n.leagueReportsModal .eEventPrintModal__itemDescription {\n  color: #69778a;\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.leagueReportsModal .eEventPrintModal__arrow {\n  color: #94a3b8;\n  font-size: 24px;\n  line-height: 1;\n}\n.leagueReportsPicker {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  padding: 18px 20px 20px;\n}\n.leagueReportsPicker > p {\n  grid-column: 1/-1;\n  margin: 0 0 5px;\n  color: #69778a;\n  font-size: 13px;\n}\n.leagueReportsPicker > button {\n  min-height: 82px;\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 11px;\n  padding: 12px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n}\n.leagueReportsPicker > button:hover:not(:disabled) {\n  border-color: #9bc9e7;\n  background: #fbfdff;\n}\n.leagueReportsPicker > button:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n.leagueReportsPicker > button > i {\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #eaf4fb;\n  color: #227ebd;\n  font-style: normal;\n}\n.leagueReportsPicker span {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.leagueReportsPicker strong {\n  color: #142033;\n  font-size: 13px;\n}\n.leagueReportsPicker small {\n  margin-top: 3px;\n  color: #69778a;\n  font-size: 11px;\n  line-height: 1.35;\n}\n.leagueReportsPicker b {\n  color: #94a3b8;\n}\n.leagueReportParametersModal.modal-dialog {\n  max-width: 660px !important;\n}\n.leagueReportParametersModal .modal-header {\n  min-height: 76px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #e3e8ef;\n  background: #fff;\n}\n.leagueReportModalTitle {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.leagueReportModalTitle__icon {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #eef8ff;\n  color: #17659a;\n}\n.leagueReportModalTitle__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n}\n.leagueReportModalTitle__copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.leagueReportModalTitle__name {\n  color: #142033;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n.leagueReportModalTitle__category {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 12.5px;\n}\n.leagueReportParametersModal .modal-body {\n  padding: 0 !important;\n}\n.leagueReportParametersModal .modal-content {\n  max-height: min(760px, calc(100vh - 40px));\n}\n.leagueReportParametersModal__body > form {\n  display: flex;\n  flex-wrap: wrap;\n  max-height: calc(100vh - 118px);\n  overflow-y: auto;\n  color: #334155;\n  font-size: 13px;\n}\n.leagueReportParametersModal__body .bReportFormTitle {\n  display: none;\n}\n.leagueReportParametersModal__body > form > .mb-3.mt-3,\n.leagueReportParametersModal__body .bReportFormTitle + .mb-3,\n.leagueReportParametersModal__body .form-check,\n.leagueReportParametersModal__body .form-group {\n  box-sizing: border-box;\n  width: calc(100% - 48px);\n  margin: 6px 24px !important;\n  padding: 13px 14px;\n  border: 1px solid #e3e8ef;\n  border-radius: 11px;\n  background: #fff;\n}\n.leagueReportParametersModal__body > form > .mb-3.mt-3,\n.leagueReportParametersModal__body .bReportFormTitle + .mb-3 {\n  margin-top: 18px !important;\n  background: #f8fafc;\n}\n.leagueReportParametersModal__body .form-check .form-check {\n  width: 100%;\n  margin: 8px 0 0 !important;\n}\n.leagueReportParametersModal__body label {\n  color: #142033;\n  font-size: 13px;\n  font-weight: 650;\n}\n.leagueReportParametersModal__body .form-control {\n  min-height: 42px;\n  border: 1px solid #cfd8e3;\n  border-radius: 9px;\n  box-shadow: none;\n}\n.leagueReportParametersModal__body .form-control:focus {\n  border-color: #2684c7;\n  box-shadow: 0 0 0 3px rgba(38, 132, 199, 0.12);\n}\n.leagueReportParametersModal__body form > .btn {\n  min-width: 96px;\n  min-height: 40px;\n  order: 98;\n  margin-top: 18px !important;\n  margin-bottom: 18px !important;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.leagueReportParametersModal__body form > .btn-secondary {\n  margin-right: 8px !important;\n  margin-left: 24px !important;\n  border-color: #cbd5e1;\n  background: #fff;\n  color: #475569;\n}\n.leagueReportParametersModal__body form > .btn-primary {\n  order: 99;\n  margin-right: 24px !important;\n  margin-left: auto !important;\n  border-color: #227ebd;\n  background: #227ebd;\n}\n\n.leagueReportParametersModal__body .sit-switch {\n  min-height: 24px;\n  align-items: center;\n}\n\n.leagueReportParametersModal__body .form-check > .d-flex {\n  align-items: center;\n}\n\n.leagueReportParametersModal__body .form-check-label {\n  margin: 0;\n}\n\n.leagueReportParametersModal__body .leagueReportForm__footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 3;\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 14px 24px;\n  border-top: 1px solid #e3e8ef;\n  background: #fff;\n}\n\n.leagueReportParametersModal__body .leagueReportForm__footer .btn {\n  min-height: 40px;\n  margin: 0 !important;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n/* Shared report controls — same structure as People / Students report modals. */\n.leagueReportParametersModal.modal-dialog {\n  height: min(760px, calc(100vh - 48px));\n}\n\n.leagueReportParametersModal .modal-content {\n  height: 100% !important;\n  max-height: 100% !important;\n}\n\n.leagueReportParametersModal .modal-body,\n.leagueReportParametersModal__body {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden !important;\n}\n\n.leagueReportParametersModal__body > form.eReportForm {\n  display: flex !important;\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  flex: 1 1 0;\n  flex-flow: column nowrap;\n  overflow: hidden;\n  background: #fff;\n}\n\n.leagueReportParametersModal .eReportForm__scroll {\n  min-height: 0;\n  flex: 1 1 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n\n.leagueReportParametersModal .eReportDescription {\n  margin: 18px 24px 8px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-body, #334155);\n  font-size: 13.5px;\n  line-height: 1.55;\n}\n\n.leagueReportParametersModal .eReportSection {\n  margin: 16px 24px 0;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n}\n\n.leagueReportParametersModal .eReportSection__heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.leagueReportParametersModal .eReportSection__icon {\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.leagueReportParametersModal .eReportSection__title {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.leagueReportParametersModal .eReportSection__required {\n  margin-left: 3px;\n  color: #c23648;\n}\n\n.leagueReportParametersModal .eReportSection__hint {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.leagueReportParametersModal .eReportToggleList {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n}\n\n.leagueReportParametersModal .eReportToggle {\n  display: flex;\n  min-height: 56px;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 13px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: #fff;\n}\n\n.leagueReportParametersModal .eReportToggle:first-child {\n  border-top: 0;\n}\n\n.leagueReportParametersModal .eReportSection > .eReportToggle {\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n}\n\n.leagueReportParametersModal .eReportToggle__copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.leagueReportParametersModal .eReportToggle__label {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.leagueReportParametersModal .eReportToggle__hint {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n\n.leagueReportParametersModal .eReportToggle .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n\n.leagueReportParametersModal .eReportSection__chips {\n  margin-top: 12px;\n}\n\n.leagueReportParametersModal .eReportCheckboxGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.leagueReportParametersModal .eReportCheckbox {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 9px;\n  border: 1px solid #dbe3ec;\n  border-radius: 999px;\n  background: #fff;\n  color: #526174;\n  font: 600 12px var(--font-body, inherit);\n}\n\n.leagueReportParametersModal .eReportCheckbox__box {\n  display: none;\n}\n\n.leagueReportParametersModal .eReportCheckbox--active {\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.leagueReportParametersModal .eReportAgeGroups {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.leagueReportParametersModal .eReportAgeGroup {\n  display: grid;\n  grid-template-columns: 72px minmax(0, 1fr);\n  gap: 10px;\n  align-items: start;\n}\n\n.leagueReportParametersModal .eReportAgeGroup__title {\n  display: flex;\n  flex-direction: column;\n  padding-top: 5px;\n  color: #334155;\n  font-size: 12px;\n}\n\n.leagueReportParametersModal .eReportAgeGroup__title span {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.leagueReportParametersModal .eReportDateRange,\n.leagueReportParametersModal .eReportDateRange__picker {\n  width: 100%;\n}\n\n.leagueReportParametersModal .eReportActions {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 9px;\n  padding: 14px 24px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: var(--slate-25, #f8fafc);\n  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.04);\n}\n\n.leagueReportParametersModal .eReportActions__status {\n  flex: 1;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.leagueReportParametersModal .eDsButton {\n  min-height: 40px;\n  padding: 8px 15px;\n  border-radius: 9px;\n  font: 700 13px var(--font-body, inherit);\n}\n\n.leagueReportParametersModal .eDsButton--secondary {\n  border: 1px solid var(--border-default, #cfd8e3);\n  background: #fff;\n  color: var(--text-strong, #142033);\n}\n\n.leagueReportParametersModal .eDsButton--primary {\n  border: 1px solid var(--blue-600, #1f78b4);\n  background: var(--blue-600, #1f78b4);\n  color: #fff;\n}\n\n@media (max-width: 560px) {\n  .leagueReportParametersModal .eReportDescription,\n  .leagueReportParametersModal .eReportSection {\n    margin-right: 14px;\n    margin-left: 14px;\n  }\n\n  .leagueReportParametersModal .eReportActions {\n    align-items: stretch;\n    flex-direction: column;\n    padding: 12px 14px;\n  }\n\n  .leagueReportParametersModal .eDsButton {\n    width: 100%;\n  }\n}\n.schoolLeaguesPage__more {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #69778a;\n}\n.schoolLeaguesPage__empty {\n  height: 180px;\n  color: #69778a !important;\n  text-align: center !important;\n}\n.schoolLeaguesPage__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  min-height: 58px;\n  margin-top: 0;\n  padding: 12px 14px;\n  border: 1px solid #dbe3ec;\n  border-top: 0;\n  border-radius: 0 0 11px 11px;\n  background: #fff;\n}\n.schoolLeaguesPage__paginationInfo {\n  color: #69778a;\n  font-size: 12px;\n  font-weight: 600;\n}\n.schoolLeaguesPage__pagination > div {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.schoolLeaguesPage__pagination > div > span {\n  min-width: 22px;\n  color: #94a3b8;\n  font-size: 12px;\n  text-align: center;\n}\n.schoolLeaguesPage__pagination button {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.schoolLeaguesPage__pagination button:hover:not(:disabled):not(.is-active) {\n  border-color: #9bc9e7;\n  background: #f7fbfe;\n  color: #155d8c;\n}\n.schoolLeaguesPage__pagination button.is-active {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.schoolLeaguesPage__pagination button.is-arrow {\n  font-size: 20px;\n  line-height: 1;\n}\n.schoolLeaguesPage__pagination button:disabled {\n  background: #f8fafc;\n  color: #b0bbc8;\n  cursor: not-allowed;\n}\n.leaguesDrawer__scrim {\n  position: fixed;\n  z-index: 1090;\n  inset: 0;\n  border: 0;\n  background: rgba(15, 23, 42, 0.35);\n}\n.leaguesDrawer {\n  position: fixed;\n  z-index: 1100;\n  top: 0;\n  right: 0;\n  display: flex;\n  width: min(500px, 100vw);\n  height: 100vh;\n  flex-direction: column;\n  background: #fff;\n  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.18);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.leaguesDrawer > header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 19px 20px;\n  border-bottom: 1px solid #e5eaf0;\n}\n.leaguesDrawer > header > i {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 11px;\n  background: #eaf4fb;\n  font-style: normal;\n  color: #227ebd;\n}\n.leaguesDrawer > header > div {\n  min-width: 0;\n}\n.leaguesDrawer h2 {\n  margin: 0;\n  color: #142033;\n  font-size: 18px;\n  font-weight: 750;\n}\n.leaguesDrawer header p {\n  margin: 3px 0 0;\n  color: #69778a;\n  font-size: 12px;\n}\n.leaguesDrawer header > button {\n  width: 34px;\n  height: 34px;\n  margin-left: auto;\n  border: 0;\n  border-radius: 8px;\n  background: #f1f5f9;\n  color: #526174;\n  font-size: 22px;\n}\n.leaguesDrawer > nav {\n  display: flex;\n  padding: 0 18px;\n  border-bottom: 1px solid #e5eaf0;\n}\n.leaguesDrawer > nav button {\n  min-height: 44px;\n  padding: 0 12px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: none;\n  color: #69778a;\n  font-size: 13px;\n  font-weight: 650;\n}\n.leaguesDrawer > nav button.is-active {\n  border-color: #227ebd;\n  color: #155d8c;\n}\n.leaguesDrawer > nav span {\n  margin-left: 5px;\n  padding: 1px 5px;\n  border-radius: 999px;\n  background: #eef2f6;\n  font-size: 9px;\n}\n.leaguesDrawer > main {\n  min-height: 0;\n  flex: 1;\n  overflow: auto;\n  padding: 18px 20px;\n}\n.leaguesDrawer > footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 13px 20px;\n  border-top: 1px solid #e5eaf0;\n}\n.eSchoolLeaguesPhotos {\n  max-width: 100%;\n  border: 0;\n  border-radius: 9px;\n}\n.bReportFormTitle {\n  font-size: 18px;\n  font-weight: bold;\n}\n.leaguesDrawer main table {\n  width: 100%;\n  margin: 0;\n  border-collapse: collapse;\n}\n.leaguesDrawer main table td {\n  padding: 10px 0;\n  border: 0;\n  border-bottom: 1px solid #e5eaf0;\n  color: #142033;\n  font-size: 13.5px;\n  vertical-align: top;\n}\n.leaguesDrawer main table td:first-child {\n  width: 38%;\n  color: #69778a;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.leaguesDrawer main table tr:last-child td {\n  border-bottom: 0;\n}\n.leaguesDrawer main .leagueEventsSummary {\n  table-layout: fixed;\n}\n.leaguesDrawer main .leagueEventsSummary th {\n  padding: 9px 10px;\n  border-bottom: 1px solid #e3e8ef;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-align: left;\n  text-transform: uppercase;\n}\n.leaguesDrawer main .leagueEventsSummary th:first-child {\n  width: 48%;\n}\n.leaguesDrawer main .leagueEventsSummary td,\n.leaguesDrawer main .leagueEventsSummary td:first-child {\n  width: auto;\n  padding: 11px 10px;\n  background: #fff;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: 0;\n  text-transform: none;\n}\n.leaguesDrawer main .leagueEventsSummary td:first-child a {\n  color: #176895;\n  font-weight: 750;\n}\n.leaguesDrawer main .leagueNewsSummary__body {\n  display: -webkit-box;\n  max-width: 220px;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  color: #64748b;\n  line-height: 1.45;\n}\n@media (max-width: 760px) {\n  .schoolLeaguesPage__header,\n  .schoolLeaguesPage__toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .leagueReportsPicker {\n    grid-template-columns: 1fr;\n  }\n  .schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {\n    width: 100%;\n  }\n  .schoolLeaguesPage__toolbar {\n    width: 100%;\n    margin-left: 0;\n  }\n  .schoolLeaguesPage__filterPopover {\n    position: fixed;\n    top: auto;\n    right: 12px;\n    bottom: 12px;\n    left: 12px;\n    width: auto;\n    max-width: none;\n  }\n}\n\n/* School leagues — shared refreshed list shell. */\n.schoolLeaguesRoute {\n  width: 100%;\n  margin-top: 0 !important;\n}\n\n.schoolLeaguesPage {\n  min-width: 0;\n  padding-bottom: 32px;\n  background: var(--surface-page, #f8fafc);\n}\n\n.schoolLeaguesPage__header {\n  box-sizing: border-box;\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 78px;\n  align-items: center;\n  gap: 24px;\n  margin: -20px 0 18px -24px;\n  padding: 14px 72px 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.schoolLeaguesPage__header > div:first-child {\n  min-width: 150px;\n  flex: 0 0 auto;\n}\n\n.schoolLeaguesPage__header h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.18;\n}\n\n.schoolLeaguesPage__toolbar {\n  align-items: center;\n  margin-left: 0;\n}\n\n.schoolLeaguesPage__filterPopover {\n  position: fixed;\n  z-index: 1300;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  width: min(420px, 100vw);\n  max-width: none;\n  height: 100vh;\n  flex-direction: column;\n  border-width: 0 0 0 1px;\n  border-radius: 0;\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.schoolLeaguesPage__popoverScrim {\n  z-index: 1290;\n}\n\n.schoolLeaguesPage__filterPopover > header {\n  margin: 18px 18px 0;\n}\n\n.schoolLeaguesPage__filterFields {\n  min-height: 0;\n  flex: 1;\n  align-content: start;\n  overflow-y: auto;\n  padding: 18px;\n}\n\n.schoolLeaguesPage__filterChips {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.schoolLeaguesPage__filterChips legend {\n  width: auto;\n  margin: 0 0 9px;\n  padding: 0;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.schoolLeaguesPage__filterChips > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.schoolLeaguesPage__filterChips button {\n  min-height: 34px;\n  padding: 6px 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.schoolLeaguesPage__filterChips button:hover {\n  border-color: #9bc9e7;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.schoolLeaguesPage__filterChips button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolLeaguesPage__filterChips button.is-selected:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n.schoolLeaguesPage__columns > .leagueButton,\n.schoolLeaguesPage__columnsMenu {\n  z-index: 1300;\n}\n\n.schoolLeaguesPage__card tbody tr {\n  height: 56px;\n}\n\n.schoolLeaguesPage__card tbody tr:hover {\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.schoolLeaguesPage__more {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 25px;\n  line-height: 1;\n  opacity: 0;\n  transition: opacity 120ms ease, color 120ms ease;\n}\n\n.schoolLeaguesPage__card tbody tr:hover .schoolLeaguesPage__more,\n.schoolLeaguesPage__card tbody tr.is-selected .schoolLeaguesPage__more {\n  color: var(--blue-600, #227ebd);\n  opacity: 1;\n}\n\n.schoolLeaguesPage__card input[type='checkbox'],\n.schoolLeaguesPage__columnsMenu input[type='checkbox'] {\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 4px;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.leagueButton:hover:not(:disabled),\n.schoolLeaguesPage__selection button:hover:not(:disabled) {\n  border-color: #9bc9e7;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.leagueButton--primary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n@media (max-width: 1040px) {\n  .schoolLeaguesPage__header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .schoolLeaguesPage__toolbar {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .schoolLeaguesPage__toolbar > .leagueButton--primary {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 620px) {\n  .schoolLeaguesPage__header {\n    width: calc(100% + 30px);\n    margin-left: -15px;\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n\n  .schoolLeaguesPage__toolbar > .schoolLeaguesPage__search {\n    width: 100%;\n  }\n\n  .schoolLeaguesPage__filterPopover {\n    width: min(390px, 100vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
